/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { map } from '@codegrade/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Counter {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(_counts) {
        this._counts = _counts;
        Object.freeze(this._counts);
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getCount(item) {
        return this._counts.get(item).orDefault(0);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static make(items, getKey, 
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getAmount = () => 1) {
        const counts = new Map();
        for (const item of items) {
            const key = getKey(item);
            const amount = getAmount(item);
            counts.set(key, (counts.get(key) ?? 0) + amount);
        }
        return new Counter(new map.ReadonlyMaybeMap(counts));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    toMap() {
        return this._counts;
    }
}
